import { render } from "./safeHtml.vue?vue&type=template&id=0203388e&scoped=true"
import script from "./safeHtml.vue?vue&type=script&lang=js"
export * from "./safeHtml.vue?vue&type=script&lang=js"

import "./safeHtml.vue?vue&type=style&index=0&id=0203388e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0203388e"]])

export default __exports__